// import jwtEncode from "https://cdn.jsdelivr.net/npm/jwt-encode@1.0.1/+esm";

export class CustomerButtons {
  constructor() {
    console.log("CustomerButtons");
    let elements = document.querySelectorAll("customer-buttons");

    if (elements.length > 0) {
      [...elements].forEach((el) => {
        this.init(el);
      });
    }
  }

  init(el) {
    let email = el.dataset.email;

    if (!email) {
      return;
    }

    const data = { email_id: email };

    // let secret = "XXXXXX";
    // let jwt = jwtEncode(data, secret);

    const jwt =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.tzenOEaA4hgPaqBI4Od1vyCfT81xbgg6N__HYO7_XPQ";
    let fitFinderButton = el.querySelector(".fit-finder-results");

    fetch("https://api-production.visualquizbuilder.com/api/public/quiz_data", {
      method: "POST",
      headers: {
        Authorization: "Token " + jwt,
        "Content-Type": "application/json",
        ACCESSKEY: "7DF811FFD7VMDBMSGUAYFWO4VWG56EF7",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.length > 0) {
          let firstResult = json[0];
          let recommendationUrl = firstResult.recommendation_url;
          fitFinderButton.setAttribute("href", recommendationUrl);
          fitFinderButton.style.display = "flex";
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const customerButtons = new CustomerButtons();
});
